import { redirect } from '@tanstack/react-router';
import { guardAutomationsSection } from '../ario/-guard';

/**
 * @desc Where an old `/admin/automations/<rest>` link now lives: the same leaf under
 * `/admin/ario/`, with its search string and hash kept, so a `?c=<conversationId>` chat link or a
 * run's own page lands where it pointed (add-ario-identity-and-authoring-round-3 D2).
 */
export const arioHref = (splat: string, searchStr: string, hash: string): string =>
  `/admin/ario/${splat.replace(/^\/+/, '')}${searchStr}${hash ? `#${hash.replace(/^#/, '')}` : ''}`;

/**
 * @desc The old tree's `beforeLoad`: with the flag off the section does not exist under either
 * path (the guard's `notFound()`); with it on, a replacing redirect, so Back never returns to the
 * old path. Kept for at least one release after the Notion and Linear links move (design §5).
 */
export function redirectToArio({
  splat,
  location,
}: {
  splat: string;
  location: { searchStr: string; hash: string };
}): never {
  guardAutomationsSection();
  throw redirect({ href: arioHref(splat, location.searchStr, location.hash), replace: true });
}
